module.exports = __webpack_public_path__ + "static/media/banner1.8a1a3e7c.png";